import { Button, MenuItem, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { saveCorrectionService, saveReversalService, updateReimbursementAll } from "../../../services/ReimbursementService";
import { useAuth } from "../../../AuthProvider";
import { Image, Select } from "antd";
import { fetchChartOfAccountsList } from '../../../accounting/services/ChartOfAccountsService';
import { fetchExpenseById } from "../../../accounting/bank/bank-reconcile/basiq/service/RetrieveRecordService";

export default function ExpenseItem(props) {
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);
    const userContext = useAuth();
    const [formData, setFormData] = useState({ claimantName: '', claimedAmount: '', extractedAmount: '', createdDate: '', createdBy: '', invoiceDate: '', transaction_reference: '', additionalInfo: '', claimantManagerId: '', s3ConnectionUrl: '', paid: props.paid === 'Y' ? 'Y' : '' });
    const [paidChecked, setPaidChecked] = useState(props.paid === 'Y');
    const [paidDisabled, setPaidDisabled] = useState(props.paid === 'Y');
    const [chartAccounts, setChartAccounts] = useState([]);
    const [selectedCoaId, setSelectedCoaId] = useState(null);
    const calculateAmountExclGST = (value) => {
        const amexgst = value - (value * 0.11);
        setFormData({ ...formData, claimedAmount: value, amountExclGST: amexgst })
    }
        // Fetch Chart of Accounts on mount
        useEffect(() => {
            const fetchCoA = async () => {
                try {
                    const res = await fetchChartOfAccountsList(userContext.token);
                    setChartAccounts(res.data || []);
                } catch (e) {
                    setChartAccounts([]);
                }
            };
            fetchCoA();
        }, [userContext.token]);

        // Prefill selectedCoaId if coaDetails exists in props
        useEffect(() => {
            if (props.coaDetails && props.coaDetails.id) {
                setSelectedCoaId(props.coaDetails.id);
            }
        }, [props.coaDetails]);
    const saveRecord = async (saveType) => {
        setLoading(true);

        if (saveType === 'saveandprogressstatus') {
            const response = await updateReimbursementAll(formData, userContext.token, props.onApprove);
            setLoading(false);
            setSaved(true);
        } else {
            const response = await updateReimbursementAll(formData, userContext.token);
            setLoading(false);
            setSaved(true);
        }
        props.onLoad();
        setTimeout(() => {
            setSaved(false);
        }, 3000);
    }
    const saveReversal = async (saveType) => {
        setLoading(true);
        const response = await saveReversalService(formData, userContext.token, props.onApprove);
        setLoading(false);
        setSaved(true);
        props.onLoad();
        setTimeout(() => {
            setSaved(false);
        }, 3000);
    }
    const saveCorrection = async (saveType) => {
        setLoading(true);
        const response = await saveCorrectionService(formData, userContext.token, props.onApprove);
        setLoading(false);
        setSaved(true);
        props.onLoad();
        setTimeout(() => {
            setSaved(false);
        }, 3000);
    }
    const handleChange = (event) => {
        setFormData({ ...formData, transactionReference: event });
    }

    // Handle Account Type dropdown change
    const handleAccountTypeChange = (val) => {
        setSelectedCoaId(val);
        const found = chartAccounts.find(acc => acc.id === val);
        setFormData({ ...formData, coaDetails: found || null });
    }
    useEffect(() => {
        console.log(props);
        setFormData({ ...formData, ...props });
    }, [props.claimantName]);

    useEffect(() => {
        console.log('Fetching expense by ID:', props.reId);
        fetchExpenseById(userContext.token, props.reId).then((data) => {
            setFormData({ ...formData, ...data[0] });
        }).catch((error) => {
            console.error('Error fetching expense by ID:', error);
        });
    }, [props.reId]);
    return (
        <div>
            <div style={{ marginBottom: 12 }}>
                <input
                    type="checkbox"
                    checked={paidChecked}
                    disabled={paidDisabled}
                    onChange={e => {
                        setPaidChecked(e.target.checked);
                        setFormData({ ...formData, paid: e.target.checked ? 'Y' : '' });
                    }}
                    style={{ marginRight: 8 }}
                />
                <span>Paid (Payment sent/complete)</span>
            </div>
            <div style={{ paddingBottom: '40px' }}>{saved ? 'Your changes are saved now' : ''}</div>
            <TextField disabled className="textField" id="claimant-name" variant="outlined" onChange={(e) => { setFormData({ ...formData, claimantFullName: e.target.value }) }} value={formData.claimantFullName} />
            <TextField disabled className="textField" id="claimant-id"  variant="outlined" onChange={(e) => { setFormData({ ...formData, claimantId: e.target.value }) }} value={formData.claimantId} />
            <TextField disabled className="textField" id="claimant-email"  variant="outlined" onChange={(e) => { setFormData({ ...formData, claimantEmail: e.target.value }) }} value={formData.claimantEmail} />
            <TextField disabled className="textField" id="supplier-name" label="Supplier/Vendor Name" variant="outlined" value={formData.supplierName} />

            <TextField className="textField" id="amount-claimed" label="Claimed amount" variant="outlined" onChange={(e) => { calculateAmountExclGST(e.target.value) }} value={formData.claimedAmount} />
            <TextField disabled className="textField" id="amount-excl-gst" label="Amount excl. GST" variant="outlined" value={formData.amountExclGST} />
            <TextField disabled className="textField" id="amount-x-claimed" label="Automatic Extracted amount" variant="outlined" onChange={(e) => { setFormData({ ...formData, extractedAmount: e.target.value }) }} value={formData.extractedAmount} />
            <div style={{ padding: '10px' }}></div>
            <Image src={formData.s3ConnectionUrl} alt="Document" />
            <div style={{ padding: '10px' }}></div>
            <TextField disabled className="textField" id="amount-x-created-date" label="Created date:" variant="outlined" onChange={(e) => { setFormData({ ...formData, createdDate: e.target.value }) }} value={formData.createdDate} />

            <TextField disabled className="textField" id="amount-x-created-by" label="Created by:" variant="outlined" onChange={(e) => { setFormData({ ...formData, createdBy: e.target.value }) }} value={formData.createdBy} />
            <TextField disabled className="textField" id="amount-x-invoice-date" label="Invoice date:" variant="outlined" onChange={(e) => { setFormData({ ...formData, invoiceDate: e.target.value }) }} value={formData.invoiceDate} />
            {formData.status === 'approved' ?
                <TextField className="textField" id="notes-to-correct" label="Reason for correction/reversal:" variant="outlined" onChange={(e) => { setFormData({ ...formData, recordReasonForChange: e.target.value }) }} value={formData.recordReasonForChange} /> : ''}



            <Select
                className='selectField'
                value={formData.transactionReference}
                onChange={handleChange}
                style={{ width: 220, marginBottom: 16 }}
                placeholder="Purpose"
            >
                <MenuItem value='TAX'>Tax Return</MenuItem>
                <MenuItem value='EXPENSE'>Expense</MenuItem>
                <MenuItem value='PERSONAL'>Personal</MenuItem>
                <MenuItem value='ACCOUNT_PAYABLE'>Account Payable</MenuItem>
            </Select>

            {/* Type of Account Dropdown */}
            <div style={{ margin: '16px 0' }}>
                <label>Type of Account</label>
                <Select
                    showSearch
                    placeholder="Select Account"
                    style={{ width: 220, marginLeft: 8 }}
                    value={selectedCoaId}
                    onChange={handleAccountTypeChange}
                    optionFilterProp="children"
                    filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
                >
                    {chartAccounts.map(acc => (
                        <Select.Option key={acc.id} value={acc.id}>{acc.accountName} ({acc.accountType})</Select.Option>
                    ))}
                </Select>
            </div>

            <TextField className="textField" id="amount-x-additional-info" label="Additional info:" variant="outlined" onChange={(e) => { setFormData({ ...formData, additionalInfo: e.target.value }) }} value={formData.additionalInfo} />
            <TextField disabled className="textField" id="amount-x-claimant-manager-id" label="Claimant Manager Id:" variant="outlined" onChange={(e) => { setFormData({ ...formData, claimantManagerId: e.target.value }) }} value={formData.claimantManagerId} />

            {(formData.transactionReference === 'ACCOUNT_PAYABLE' && formData.status === 'pending') ?
                <div>
                    <TextField className="textField" id="amount-x-purchase-order" label="Purchase order no" variant="outlined" onChange={(e) => { setFormData({ ...formData, purchaseOrderNo: e.target.value }) }} value={formData.purchaseOrderNo} />

                    <TextField className="textField" id="amount-x-invoice-date" label="AP invoice issue date" variant="outlined" onChange={(e) => { setFormData({ ...formData, apInvoiceIssueDate: e.target.value }) }} value={formData.apInvoiceIssueDate} />
                    <TextField className="textField" id="amount-x-payment-due" label="Payment due date" variant="outlined" onChange={(e) => { setFormData({ ...formData, apPaymentDueDate: e.target.value }) }} value={formData.apPaymentDueDate} />
                    <div><Button className="buttonField" variant="contained" onClick={saveRecord}>Save</Button>
                        <div style={{ padding: '10px' }}></div>

                        <Button className="buttonField" variant="contained" onClick={() => saveRecord('saveandprogressstatus')}>Save & {formData.nextSubStatus}</Button></div>
                </div>
                : ''

            }

            {(formData.claimantManagerId===userContext.additionalUserInfo.reportingManagerId || userContext.role === 'ROLE_SADMIN' || userContext.role==='ROLE_CMANAGER') ?
                <Button className="buttonField" variant="contained" onClick={saveRecord}>Save</Button> : ''}

            {formData.status === 'approved' && (formData.claimantManagerId===userContext.additionalUserInfo.reportingManagerId || userContext.role === 'ROLE_SADMIN' || userContext.role==='ROLE_CMANAGER') ?
                <Button className="buttonField" variant="contained" onClick={saveCorrection}>Correct and Save</Button> : ''}
            {formData.status === 'approved'  && (formData.claimantManagerId===userContext.additionalUserInfo.reportingManagerId || userContext.role === 'ROLE_SADMIN' || userContext.role==='ROLE_CMANAGER') ?
                <Button className="buttonField" variant="contained" onClick={saveReversal}>Reject (Reverse)</Button> : ''}




        </div>
    )

}